import { useState } from 'react';

export function useRefundOrder() {
    const [refundOrder, setRefundOrder] = useState();
    return {
        refundOrder,
        setRefundOrder,
    };
}
